import {http,baseGatewayURL} from './index';
import {IReqProcessListParams,IReqGetOrganizationTreeParams, IReqReportVisitParams, IReqchangeCrocessTeacherIdParams, IReqliveLessonServiceTimeParams, IReqPushCallId, IReqHangupCallRecord, IRequpdateCallRecord,IReqGetStudyRecord, IReqTransferTeacherPageParams, IReqShortLinkParams} from '@types';

//查询组织结构所有老师
export const getOrganizationTree  = (params:IReqGetOrganizationTreeParams) => http.get(`/olaf/api/v1/permission/node/${params.roleId}/${params.userId}`);
//查询私教服务列表数据
export const getProcessList = (params: any) => http.post('/teaching-workbench/booking/process-list', params);
//报备
export const reportVisit = (params: IReqReportVisitParams) => http.post('/teaching-workbench/booking/v2/report-visit', params);
//课程开始前判断
export const getClassCanEnter = (params: {processId:number | string}) => http.get('/teaching-workbench/booking/v2/finished-check', params);
//转移导师
export const changeCrocessTeacherId = (params: IReqchangeCrocessTeacherIdParams) => http.post('/teaching-workbench/booking/teacher/process-teacher/update', params);
//同步直播课服务时间
export const liveLessonServiceTime = (params: IReqliveLessonServiceTimeParams) => http.post('/teaching-workbench/api/v2/booking/live-lesson-service-time', params);
//列表导出接口
export const bookingExport = (params: IReqProcessListParams) => http.post('/teaching-workbench/booking/process-export', params, { responseType: 'blob'});

//操作日志记录查询
export const getOperateRecord  = (params:{processId:number,pageSize?:number,pageNum?:number}) => http.get('/teaching-workbench/booking/operate/record/get',params);
//查询预约详情V2
export const getBookingDetail = (params: {
    processId:number|string,
    userId:number,
    serverType:string,
}) => http.post('/teaching-workbench/booking/detail/v2', params);
//查询学员信息接口
// export const getMemberDetail  = (params:{memberId:number|string}) => http.get(`/olaf/api/v1/member/${params.memberId}`,params);
export const getMemberDetail  = (guid:number|string) => http.get(`/olaf/api/v1/member/guid/${guid}`);


//电话ID推送接口
export const pushCallId = (params: IReqPushCallId) => http.post('/teaching-workbench/booking/phone/save/call-record', params);
//结束辅导
export const teacherFinished = (params: {processId:string|number,processIds?:number[]}) => http.post('/teaching-workbench/booking/process/call/finish', params);
//老师取消学生的预约
export const teacherCancel = (params: {bookingId:string|number,reasonType:number,reasonStr:string}) => http.post('/teaching-workbench/booking/teacher/cancel', params);
//学生未接听私教电话 联系不上
export const teacherNoAnswer  = (params:{processId:number|string}) => http.get('/teaching-workbench/booking/teacher/no-answer',params);
//提醒学员修改问题
export const questionRemind = (params: {processId:string|number,cause:number,content?:string}) => http.post(`/teaching-workbench/booking/question/remind/${params.processId}`, params);
//查询学员历史提问问题列表
export const getHistoryQuestion  = (params:{processId:number|string}) => http.get(`/teaching-workbench/booking/question/${params.processId}/list`,params);
//添加服务记录
export const addprocessServiceRecord = (params: {
    classState:number,
    content:string,
    bookingId:number|string,
    recordType:number
}) => http.post('/teaching-workbench/booking/add/process/service/record', params);
//批量获取当前预约下的通话数据接口 电话录音
export const getCallDetails  = (params:{processId:number|string}) => http.get('/teaching-workbench/booking/phone/get/call-records',params);
// 会议纪要下载地址有时效性，每次打开时重新查询
export const getBookingMeetingRecords = (params: {processId: number | string}) => http.get('/teaching-workbench/booking/v2/meeting-records', params);
//获取反馈报告
export const getFeedbackReport  = (params:{processId:number|string}) => http.get(`/elune/api/v1/booking/process/feedback/report/${params.processId}`,params);
//老师提交反馈报告
export const submitFeedbackReport = (params: {
    processId:number|string,
    userId:number|string,
    summary:string,
    suggest:string,
    feedbackFiles?:{name:string,path:string}[],
    commit:number
}) => http.post('/teaching-workbench/booking/save/teacher/feedback/report', params);
//根据登录老师的userID获取ocrm系统话务配置接口
export const getCallConfig  = (params:{userId:number}) => http.get('/solon/internal/v1/call-record/call_record_configs',params);
//挂断电话上报通话数据
export const hangupCallRecord = (params: IReqHangupCallRecord) => http.post('/solon/internal/v1/call-record/hangup', params);

//学员评价查询
export const getStudentAppraisal  = (params:{processId:number|string}) => http.get(`/teaching-workbench/booking/appraisal/${params.processId}`);

export const getupLoadUrl = () => `${baseGatewayURL}/base/v1/upload/upload`;

//转移导师 老师列表
export const transferTeacherList = (params: {
    flag:string,
    roleIdList:number|string[],
    teacherIdList?:number[]
}) => http.post('/teaching-workbench/booking/teacher/process-teacher/list', params);

//转移导师 老师列表（分页）
export const transferTeacherPage = (params: IReqTransferTeacherPageParams) => http.post('/teaching-workbench/booking/teacher/process-teacher/page', params);

//根据预约id取测评报告地址
export const getEvaluationInfo  = (params:{processId:number|string}) => http.get('/olaf/api/v1/booking/evaluation/teacher/process/detail',params);

//查询关联课程列表
export const relevanceCourseList  = (params:{processId:number|string}) => http.get(`/teaching-workbench/booking/report/relevance/${params.processId}`);

//接通电话后上报
export const updateCallRecord = (params: IRequpdateCallRecord) => http.post('/teaching-workbench/booking/phone/update/call-record', params);

//查询学生学习记录
export const getStudyRecord = (params:IReqGetStudyRecord) => http.post('/teaching-workbench/booking/study/record', params);

//查询 学员 评价数据
export const getEvaluationResultTask = (params:{
    sceneId: number, version:string, businessUnitId?:number, studentId:number|string,
}) => http.get('/evaluation/api/v1/teacher/student/evaluation/result', params);


//解密学员手机号
export const getDecryptMemberMobile = (params:{
    isPersonalTraining: boolean, //是否是私教预约手机号 true-是 false-否
	mobileText:string, //密文
}) => http.post('/teaching-workbench/booking/v2/decrypt/member/mobile', params);


//查询呼叫记录
export const getCallRecords = (processId: number | string): any => http.get(`/teaching-workbench/booking/v2/call-record/${processId}`);

// 获取测评地址
export const getReportUrl = (params: any) => http.get('/ep-study/front/report/url', params);

/** 获取短链信息 GET /ep-backend/api/v1/backend/short-link */
export const getShortLink = (params: IReqShortLinkParams) => http.get('/ep-backend/api/v1/backend/short-link', params);

//根据直播间id，查询助教+访客地址
export const getVisitorUrl = (params: any) => http.get('/teaching-workbench/booking/v2/live/visitor/url', params);
